import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";

export const keyAvatars: BaseKeyFunction = () => ["avatars"];
